import {Message} from 'iview';
import Vue from 'vue'
import store from '../index'
var webSocketHost = process.uniEnv.WS_HOST;
import { GetAllNoRedNum,GetMessageCount } from "@/api/chat.js";
import request from "@/utils/chat.js";
var chat_self = '_user'

const state = () => ({
  ws: '',
  chatNum: 0,
  styleNum:0,
  messageNum:0,
  visitorNum:0,
  message: null,
  isShowChat: false,
  procurementChatShow: false,
  chat_uuids:null,
  re_call_chat_uuid:'',
  timer:null
})

const getters = {
  chatNum: (state) => state.chatNum,
  styleNum: (state) => state.styleNum,
  messageNum: (state) => state.messageNum,
  visitorNum: (state) => state.visitorNum,
  totalNum: (state) => {
    return state.chatNum + state.messageNum + state.styleNum + state.visitorNum
  }
}
const mutations = {
  setChatShow(state, isShow) {
    state.isShowChat = isShow
  },
  setProcurementChatShow(state, isShow) {
    state.procurementChatShow = isShow
  },
  setChatNumReduce(state, num) {
    state.chatNum =  state.chatNum - num
  },
  setStyleNumReduce(state, num) {
    state.styleNum =  state.styleNum - num
  },
  setMessageNull(state) {
    state.message = null
  },
  init(state, onReconnect) {
    // 防御：state.ws 可能是 localStorage 反序列化出来的死对象
    if (state.ws && typeof state.ws.close === 'function' && state.ws.readyState !== WebSocket.CLOSED) {
      try {
        state.ws.close()
      } catch (e) {
        console.warn('[scoket] 关闭旧连接失败：', e)
      }
    }
    state.ws = ''

    if (process.env.NODE_ENV == 'development') {
      state.ws = new WebSocket('ws://' + webSocketHost)
    } else {
      state.ws = new WebSocket('wss://' + webSocketHost)
    }
    state.ws.onopen = function () {
      console.log('连接成功')
      // 心跳必须用 JSON.stringify 转成字符串，WebSocket.send() 不支持直接传对象
      // 周期(50s) < 服务端 pingInterval(60s)，保证服务端不会判定连接超时
      state.timer = setInterval(function() {
        if (state.ws && state.ws.readyState === WebSocket.OPEN) {
          state.ws.send(JSON.stringify({type: "ping"}))
        }
      }, 50000);
    }
    state.ws.onerror = function () {
      console.log('web断开失败，3秒后自动重连...')
      if (state.timer) {
        clearInterval(state.timer)
        state.timer = null
      }
      if (typeof onReconnect === 'function') {
        setTimeout(onReconnect, 3000)
      }
    }
    state.ws.onclose = function () {
      console.log('连接关闭，3秒后自动重连...')
      if (state.timer) {
        clearInterval(state.timer)
        state.timer = null
      }
      if (typeof onReconnect === 'function') {
        setTimeout(onReconnect, 3000)
      }
    }
    state.ws.onmessage = function (msg) {
      console.log(msg,"msg")
      var data = JSON.parse(msg.data)
      switch (data.type) {
        //初始化,绑定
        case 'init':
          // 防御：如果 userInfo 还没有 id，延迟重试等待获取到后再绑定
          const tryBind = (retry = 0) => {
            const uid = store.state.userInfo && store.state.userInfo.id;
            if (uid) {
              var sendMsg = {
                type: 'bind',
                client_id: data.client_id,
                uid: uid + chat_self,
              }
              request.post('bind_uid', sendMsg)
            } else if (retry < 10) {
              console.warn('[scoket] userInfo.id 未就绪，200ms 后重试 bind_uid，次数：', retry + 1)
              setTimeout(() => tryBind(retry + 1), 200)
            } else {
              console.error('[scoket] userInfo.id 仍未获取到，bind_uid 绑定失败')
            }
          };
          tryBind()
          break
        case 'send':
          state.message = JSON.stringify(data.message)
          if(data.message.design_uuid) {
            state.styleNum++
          } else {
            state.chatNum++
          }
          if (!state.isShowChat) {
            let message = data.message.message
            if (data.message.message_type == 'file') {
              message = '[文件]'
            }
            if (data.message.message_type == 'img') {
              message = '[图片]'
            }
            Message.success('你有新的消息:'+message);
          }
          break
        case 'other_read':
          console.error(123)
          state.chat_uuids = JSON.stringify(data.chat_uuids)
          break
        case 'reCall':
            state.re_call_chat_uuid = data.chat_uuid
            console.error(data.chat_uuid)
            break
        // 代购员-采购人员 独立沟通：新消息 / 撤回
        case 'sendProcurement':
          console.log('[ProcurementChat][pc-scoket] 收到 sendProcurement 推送', data.message)
          Vue.prototype.$EventBus.$emit('procurement-message', data.message)
          // 采购聊天窗口打开时静默（避免正在看却弹通知）
          if (!state.procurementChatShow) {
            // 声音 + 系统通知
            try {
              new Audio(require('@/assets/notice.mp3')).play()
            } catch (e) {}
            let pmsg = (data.message && data.message.message) || ''
            if (data.message && data.message.message_type == 'img') pmsg = '[图片]'
            if (data.message && data.message.message_type == 'file') pmsg = '[文件]'
            Message.success('你有新的消息:' + pmsg)
          }
          break
        case 'sendProcurementRecall':
          Vue.prototype.$EventBus.$emit('procurement-message-recall', data.chat_uuid)
          break
      }
    }
  },
  close(state) {
    // 防御：state.ws 可能是 localStorage 反序列化出来的死对象（WebSocket 不可用）
    // 必须是 WebSocket 实例且状态可关闭时才调用 close()
    if (state.ws && typeof state.ws.close === 'function' && state.ws.readyState !== WebSocket.CLOSED) {
      try {
        state.ws.close()
      } catch (e) {
        console.warn('[scoket] 关闭旧连接失败：', e)
      }
    }
    state.ws = ''
    if (state.timer) {
      clearInterval(state.timer)
      state.timer = null
    }
  },
}
const actions = {
  webSocketInit({ commit }) {
    commit('close')
    commit('init', () => {
      // 本地开发环境不自动重连，便于调试
      if (process.env.NODE_ENV == 'development') {
        console.warn('本地开发环境，不自动重连')
        return
      }
      commit('close')
      commit('init', () => {})
    })
  },
  closeWs({ commit }) {
    commit('close')
  },
  async getMessage({ commit, state }) {
    let { data } = await GetAllNoRedNum();
    state.chatNum = data.chatNum
    state.styleNum = data.styleNum
    state.visitorNum = data.visitorNum || 0;
    let message = await GetMessageCount()
    state.messageNum =message.data.all;
  },
}
export default { state, getters, mutations, actions,namespaced: true, }
